import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";
import { UNITS } from "./formula-units";

/**
 * Formulas for AVERAGE_DEPTH
 *
 * Formula: Units / Plan Rows
 * For door, subtotal, total, if the unit value is:
 * - non-zero. Then plan row is always 1. A non-zero unit
 *   divided by 1 is the unit itself
 * - zero. Then plan row is 0. Zero unit is not shown
 *   and undefined.
 *
 * Example:
 * Door 1: 30 Units, Plan Row is thus 1, Avg Depth: 30 / 1 = 30
 * Door 2: 0 Units, Plan Row is thus 0, Avg Depth: 0 / 0 = undefined
 */
export const AVERAGE_DEPTH = ({ factoryOptions, getterParams }) => {
    return referenceMetricValueOrCompute(
        () => UNITS({ factoryOptions, getterParams }),
        getterParams,
        MetricsKind.UNITS
    );
};
